import React from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import CalendarLocale from '@fullcalendar/core/locales/pt-br'

export default props => (
  <FullCalendar
    handleWindowResize
    locale={CalendarLocale}
    plugins={[dayGridPlugin]}
    defaultView="dayGridMonth"
    headerToolbar={{
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,dayGridWeek,dayGridDay',
    }}
    businessHours={{
      daysOfWeek: [1, 2, 3, 4, 5],
    }}
    {...props}
  />
)
